module.exports = __webpack_public_path__ + "img/SouthAustraliaMap_KI.4290c324.png";